import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@pdfking/components"
import type { ComponentChildren } from "preact"

export type TooltipSide = "top" | "right" | "bottom" | "left"
export type ButtonVariant = "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
export type ButtonSize = "default" | "xs" | "sm" | "lg" | "icon" | "icon-xs" | "icon-sm" | "icon-lg"

// An icon-only Button whose tooltip is the real Tooltip component (hover +
// focus, positioned, styled) instead of the browser's native `title`.
export function TooltipIconButton({
  children,
  className = "",
  disabled,
  onClick,
  side = "bottom",
  size = "icon-xs",
  tabindex,
  title,
  variant = "outline",
}: {
  children: ComponentChildren
  // Reaches the actual <button> (see the span note below) — e.g. the
  // rounded-corner/border overrides `ButtonGroup` would normally apply to a
  // direct child, since here it's a grandchild instead.
  className?: string
  disabled?: boolean
  onClick: (e: MouseEvent) => void
  side?: TooltipSide
  size?: ButtonSize
  tabindex?: number
  title: string
  variant?: ButtonVariant
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* Radix's Slot needs a real DOM element to attach the ref/position
            calc to — `Button` doesn't forward one in this preact setup, so it
            goes through a plain span instead (same pattern as RangeControl). */}
        <span className="inline-flex">
          <Button
            className={className}
            disabled={disabled}
            onClick={onClick}
            size={size}
            tabindex={tabindex}
            variant={variant}
          >
            {children}
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent side={side}>{title}</TooltipContent>
    </Tooltip>
  )
}
